import React, { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { FaFacebook } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../actions";
import { toast } from "react-toastify";

const Login = () => {
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [isLoading, setisLoading] = useState(false);

  const navigate = useNavigate();

  const loginUser = () => {
    setisLoading(true);
    login(email, password)
      .then((res) => {
        if (res.status == 201) {
          navigate("/dashboard/start");
          toast.success("Login Successfully!");
          localStorage.setItem("accessToken", res.data.accessToken);
          localStorage.setItem("userDetails", JSON.stringify(res.data.user));
          window.location.reload();
        } else if (res.data.statusCode === 403) {
          toast.warning("Account Verification in progress!");
          isLoading(false);
        } else if (res.data.statusCode == 404) {
          toast.error("Error! User Not Found");
          isLoading(false);
          debugger;
        } else {
          isLoading(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        debugger;
      });
  };
  return (
    <div className="z-0">
      <Header />
      <div className="container pb-20 z-50 flex">
        <div className="w-full max-w-md mb-10">
          <h2 className="font-bold tracking-tight text-indigo-600 sm:text-5xl md:text-4xl">
            Login
          </h2>
          <div className="space-y-5">
            <div className="mt-10">
              <label for="first-name" class="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                onChange={(e) => setemail(e.target.value)}
                value={email}
                type="email"
                name="first-name"
                id="first-name"
                autocomplete="given-name"
                className="mt-1 block w-full py-2 rounded-md border-2 border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div className="mt-4">
              <label for="first-name" class="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                onChange={(e) => setpassword(e.target.value)}
                value={password}
                type="password"
                name="first-name"
                id="first-name"
                autocomplete="given-name"
                className="mt-1 block w-full py-2 rounded-md border-2 border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <button
                disabled={isLoading}
                onClick={() => loginUser()}
                className="w-full bg-indigo-500 p-2.5 text-white rounded hover:bg-indigo-600"
              >
                <div className="flex justify-center">
                  Log In{" "}
                  {isLoading && (
                    <div className="ml-3">
                      <svg
                        class="inline mr-2 w-4 h-4 text-white animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="sr-only">Loading...</span>
                    </div>
                  )}
                </div>
              </button>
            </div>
            <div>
              <button className="w-full bg-blue-500 p-2.5 text-white rounded hover:bg-blue-600">
                <div className="text-center d-flex justify-center">
                  <FaFacebook className="text-2xl mr-2" /> Continue with Facebook
                </div>
              </button>
            </div>
            <div>
              <button className="w-full bg-slate-200 p-2.5 rounded hover:bg-slate-300">
                <div className="text-center d-flex justify-center">
                  <FcGoogle className="text-2xl mr-2" /> Continue with Google
                </div>
              </button>
            </div>
          </div>
        </div>

        <div className="hidden text-center justify-center lg:flex">
          <img
            className="text-center w-3/4 relative -top-20"
            src={require("../assets/Mobilelogin.png")}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
